export enum MyGamesSource {
  ALL = 'all',
  HOSTED = 'hosted',
  PLAYER = 'player'
}
